export const GET_ALL_BOT_LOGS = "bots/logs";
export const GET_BOT_INFO = "bots";
export const UPDATE_NGWORDS = "bots/ngword";
export const UPDATE_BOT_LOGS = "bots/logs";